import type { Element } from 'html-react-parser';

export const hasRichText = <T>(text: T): text is StripMaybe<T> => Boolean(text && text !== '<p><br></p>');

export const isEmptyBr = (node: Element[]) => node.length === 1 && node[0].name === 'br';
